import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ResponseModel } from '../models/response';

@Injectable({
  providedIn: 'root'
})
export class ClaroPayService {

  constructor(private readonly http: HttpClient) { }

  createClaroPayLink(requestBody): Observable<ResponseModel> {
    const url = `${environment.urlglobal_api}/api/v3/checkout/claropay/handler`;
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: requestBody.token
      })
    }
    return this.http.post<ResponseModel>(url, requestBody, headers).pipe(map((res: ResponseModel) => res));
  }

  claroPayPaymentInfo(requestBody, token: string): Observable<ResponseModel> {
    const url = `${environment.urlglobal_api}/api/v3/checkout/claropay/paymentinfo`;
    const headers = {
      headers: new HttpHeaders({
        CheckoutAuthorization: token,
        'Content-Type': 'application/json',
      })
    }
    return this.http.post<ResponseModel>(url, requestBody, headers).pipe(map((res: ResponseModel) => res));
  }
}
